/*
 * routes.js
 *
 * Description: Holds common/global Routes for Module::'Checkout'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021,2022 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import HomeCheckout from '../../../components/checkout/Home.vue'; // 'Home-Checkout' ..
import Success from '../../../components/checkout/success/Success.vue'; // 'Checkout => Success' ..
import Abort from '../../../components/checkout/abort/Abort.vue'; // 'Checkout => Abort' ..

export const routescheckout = [
    { path: '', component: HomeCheckout },
    { path: '/success/:modulo?', name: 'Success', component: Success, props: true },
    { path: '/abort/:modulo?', name: 'Abort', component: Abort, props: true },
];
